import React from 'react';
import { Box } from '@chakra-ui/react';
import IchiLogo from 'src/assets/images/logo/ichi.svg';

export const IchiBadge = () => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'blue.1',
        borderRadius: '3px',
        height: '24px',
        width: 'fit-content',
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <IchiLogo />
    </Box>
  );
};
